import Vue from "vue";

import LeftNavMenuStatic from "./LeftNavMenu-Static.vue";

export function load() {
    const selector = "left-nav-menu-static";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(LeftNavMenuStatic, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
